/**
 * Program: SDLUtil.js
 * Author: SDL
 * Description: SDL Common Util
 */
import Vue          from 'vue';
import axios        from 'axios';
import _            from 'lodash';
import moment       from 'moment';
import qs           from 'query-string';
import constants    from '@/constants';
import store        from '@/vuex/store';
import api          from '@/service';
import StringUtil   from '@/utils/StringUtil';
import SdlModal     from '@/components/common/control/modal';
import Vuei18n      from '../i18n';

let API_URL = "";
const isLocalHost = `${constants.NODE_ENV}`;
if(isLocalHost === 'local') {
    API_URL = `${constants.API_HOST}:${constants.API_PORT}${constants.API_CONTEXT_PATH.replace(/\/$/, '')}`;

} else {
    API_URL = `${constants.API_CONTEXT_PATH.replace(/\/$/, '')}`;
}
/*
let API_URL = (document.location.protocol === 'http:') ?
            `${constants.API_HOST}:${constants.API_PORT}${constants.API_CONTEXT_PATH.replace(/\/$/, '')}` :
            `${constants.API_HOST_SSL}:${constants.API_PORT_SSL}${constants.API_CONTEXT_PATH.replace(/\/$/, '')}`;
*/

const API_CONTEXT_PATH = `${constants.API_CONTEXT_PATH.replace(/\/$/, '')}`;
const WEB_CONTEXT_PATH = `${constants.WEB_CONTEXT_PATH.replace(/\/$/, '')}`;
const IS_DEV_MODE = `${constants.DEV_MODE === 'Y' ? true : false}` ;
let codeList = [];

let DOTCOM_URL = (document.location.protocol === 'http:') ?
                `${constants.DOTCOM_HOST}:${constants.DOTCOM_PORT}${constants.DOTCOM_CONTEXT_PATH}` :
                `${constants.DOTCOM_HOST_SSL}:${constants.DOTCOM_PORT_SSL}${constants.DOTCOM_CONTEXT_PATH}`;

/**
 * param:
 * return: boolean
 * exception:
 * Description : Check whether you are logged in or not
 */
const isLogin = () => {
    let token = store.getters.getToken || '';
    return localStorage.getItem('user') !== null && localStorage.getItem('user') !== '' && token !== '';
};

// EUR 로그인 - 2020.09.10 김남갑 추가
const isEurLogin = () => {
    let guid = store.getters.getGuid; // GUID(SA)
    console.log('isEurLogin.guid ===> ', guid);
    let loginId = store.getters.getLoginId; // bpNo(BP)
    console.log('isEurLogin.loginId ===> ', loginId);
    console.log('isEurLogin.eurUser ===> ', localStorage.getItem('eurUser'));
    if (guid && loginId && localStorage.getItem('eurUser')) return true;
    else                                                    return false;
};

/**
 * param:
 * return: boolean
 * exception:
 * Description : Check localhost
 */
const isLocal = () => {
    const host = `${constants.API_HOST}`;
    if(
        host.indexOf('localhost') > -1
     || host.indexOf('127.0.0.1') > -1
     || document.location.hostname === 'localhost'
     || document.location.hostname === '127.0.0.1'
    ) {
        return true;

    } else {
        return false;
    }
};

/**
 * param:
 * return: boolean
 * exception:
 * Description : Check mobile
 */
const isMobile = () => {
    let device = localStorage.getItem('device') || 'desktop',
        width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;

    return device === 'mobile' ? true : (width > 1024 ? false : true);
};

/**
 * param:
 * return: boolean
 * exception:
 * Description : Check token expired
 */
const isTokenExpire = () => {
    const lastAccessTimeNumber = !isNull(localStorage.getItem('lastAccessTime')) ? Number(localStorage.getItem('lastAccessTime')) : 0;
    if (isLogin() && (!isNaN(lastAccessTimeNumber) || lastAccessTimeNumber !== 0)) {
        const lastAccessTime = moment(lastAccessTimeNumber);

        const parseToken = parseJwt(store.getters.getToken);
        const exp = moment(parseToken['exp'] * 1000);
        Vue.$log.info("※ Token expire date : ", exp.format('YYYY-MM-DD HH:mm:ss'), "/ Last Access Time : ", lastAccessTime.format('YYYY-MM-DD HH:mm:ss'));
        if(exp.diff(moment()) < 0) {
            return true;

        } else {
            return false;
        }

    } else {
        // 로그인 상태가 아니면 토큰 만료로 본다.
        return true;
    }
};

/**
 * param:
 * return: json userinfo
 * exception:
 * Description : Logged in User Information
 */
const getLoginedUserInfo = () => {
    if (isLogin()) {
        return JSON.parse(localStorage.getItem('loginUser'));
    }
    return undefined;
};

/**
 * param: userRole string
 * return: T/F
 * exception:
 * Description : whether role exists or not for the logged in user.
 */
const isRoleExist = (role) => {
    const userRoles = store.getters.getRoles;
    return userRoles.includes(role);
};

/**
 * param: key : message key(String)
 * param: replaces : param(Array) ex) properties text : {0} {1} three => param ["one", "two"]
 * return: string
 * exception:
 * Description : get message properties
 */
const getMsgProp = (key, replaces) => Vuei18n.t(key, replaces);

/**
 * param:
 * return: string
 * exception:
 * Description : the language currently set
 */
const getI18nLanguage = () => Vuei18n.locale;

/**
 * param: lang(String)
 * return:
 * exception:
 * Description : Language Settings
 */
const setI18nLanguage = lang => {
    Vuei18n.locale = lang;
};

/**
 * param: msg -> message(String)
 * param: title -> title(String)
 * param: okLabel -> ok button text(String)
 * param: onOkEvt -> ok click event(Function)
 * return:
 * exception:
 * Description : alert
 */
const alert = params => {
    let param = {
        msg: '',
        title: '',
        class: '',
        okLabel: '',
        onOkEvt: () => {},
    };
    if (typeof params === 'string') {
        param = Object.assign(param, { msg: params });
    } else {
        param = Object.assign(param, params);
    }
    SdlModal.event.$modal.show('dialog', {
        title: getMsgProp(param.title) || getMsgProp('TITLE.GLOBAL.POPUP.ALERT'),
        text: getMsgProp(param.msg),
        class: param.class ? param.class : 'sm_size',
        buttons: [
            {
                title: getMsgProp(param.okLabel) || getMsgProp('BUTTON.GLOBAL.OK'),
                default: false,
                handler: () => {
                    SdlModal.event.$modal.hide('dialog');
                    if (param.onOkEvt !== null && typeof param.onOkEvt === 'function') {
                        param.onOkEvt();
                    }
                },
            },
        ],
    });
};

/**
 * param: error message(json)
 * return:
 * exception:
 * Description : error alert
 */
const errorAlert = err => {
    let msg = 'MESSAGE.ERROR.SYSTEM'; // default error 메세지
    if (err && err.data && err.data.error) {
        if (err.data.error.reason && err.data.error.reason !== '') {
            msg = err.data.error.reason;
        } else if (err.data.error.message) {
            msg = err.data.error.message;
        }
    }
    alert({ title: 'TITLE.WARNING.TITLE', msg: msg });
};

/**
 * param: msg -> message(String)
 * param: title -> title(String)
 * param: okLabel -> ok button text(String)
 * param: cancelLabel -> cancel button text(String)
 * param: onOkEvt -> ok click event(Function)
 * param: onCancelEvt -> cancel click event(Function)
 * return:
 * exception:
 * Description : confirm
 */
const confirm = params => {
    let param = {
        msg: '',
        title: '',
        okLabel: '',
        cancelLabel: '',
        onOkEvt: () => {},
        onCancelEvt: () => {},
    };
    param = Object.assign(param, params);
    SdlModal.event.$modal.show('dialog', {
        title: getMsgProp(param.title) || getMsgProp('BUTTON.GLOBAL.CONFIRM'),
        text: getMsgProp(param.msg),
        buttons: [
            {
                title: getMsgProp(param.cancelLabel) || getMsgProp('BUTTON.GLOBAL.CANCEL'),
                default: true,
                handler: (e, s) => {
                    SdlModal.event.$modal.hide('dialog');
                    if (param.onCancelEvt !== null && typeof param.onCancelEvt === 'function') {
                        // 20.05.28 fix - X 버튼으로 Close 한 경우 는 이벤트를 실행하지 않음
                        Vue.$log.info('dialog close button class name => ', s.target.className);
                        if(s.target.className !== 'ui_close') {
                            param.onCancelEvt();

                        } else {
                            // 20.08.10 - ui_close 클릭 시, 로딩바가 해제되지 않는 문제를 해결하기 위해 로딩바 해제
                            showLoadingBar(false);
                        }
                    }
                },
            },
            {
                title: getMsgProp(param.okLabel) || getMsgProp('BUTTON.GLOBAL.CONFIRM'),
                default: false,
                handler: () => {
                    SdlModal.event.$modal.hide('dialog');
                    if (param.onOkEvt !== null && typeof param.onOkEvt === 'function') {
                        param.onOkEvt();
                    }
                },
            },
        ],
    });
};

/**
 * param: modal (import vue)
 * param: Please refer to http://devops.sdsdev.co.kr/confluence/display/SDL/Modal
 * return:
 * exception:
 * Description : modal popup
 */
const show = (modal, ...args) => {
    SdlModal.event.$modal.show(modal, ...args);
};

/**
 * param: true/false (Boolean)
 * return:
 * exception:
 * Description : default loading bar show/hide
 */
const showLoadingBar = flag => {
    if (flag) {
        SdlModal.event.$modal.show('loadingbar');
    } else {
        SdlModal.event.$modal.hide('loadingbar');
    }
};

/**
 * param: (String) categoryId
 * return: (array) combolist <Promise>
 * exception:
 * Description : Code list return for a specific parentId in the entire code list
 */
const getCommCodeList = categoryId => {
    try{
        const resp = api.getCommonCodeList(categoryId);
        return resp;

    } catch(err) {
        Vue.$log.warn('SDLUtil.getCommCodeList [\'' + categoryId + '\'] =>', err);
        return [];
    }
};

const getBoardSearchParams = boardId => {
    let boardParams = store.getters.getParams.boardParams || [];
    if(boardParams.length > 0) {
        const bIdx = _.findIndex(boardParams, function(b){ return b.boardId == boardId });
        if(bIdx >= 0) {
            return boardParams[bIdx];
        } else {
            return {};
        }

    } else {
        return {};
    }
};

/**
 * param: url -> script url path
 * return:
 * exception:
 * Description : es6 can not be imported from es legacy script.
 */
const importJS = url => new Promise((resolve, reject) => {
    // Skip if it already exists
    if (document.querySelectorAll(`script[src="${url}"]`).length !== 0) {
        resolve(window);
        return;
    }
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.addEventListener('load', () => resolve(window), false);
    script.addEventListener('error', () => reject(script), false);
    document.body.appendChild(script);
});

const importCSS = url => new Promise((resolve, reject) => {
    // Skip if it already exists
    if (document.querySelectorAll(`link[href="${url}"]`).length !== 0) {
        resolve(window);
        return;
    }
    const style = document.createElement('link');
    style.type = 'text/css';
    style.rel = "stylesheet";
    style.href = url;
    style.addEventListener('load', () => resolve(window), false);
    style.addEventListener('error', () => reject(style), false);
    document.body.appendChild(style);
});

/**
 * param: Object
 * return: formData
 * exception:
 * Description : change object to formData
 */
const formParameters = obj => {
    const formData = new FormData();
    Object.keys(obj).forEach(key => {
        if (obj[key]) {
            formData.append(key, obj[key]);
        }
    });
    return formData;
};

const validList = [];

/**
 * param: Object
 * return:
 * exception:
 * Description : Get Validation on Page as a list
 */
const getValidList = () => {
    return validList;
};

/**
 * param: Object
 * return:
 * exception:
 * Description : Save Validation on Page as a list
 */
const setValidList = el => {
    validList.push(el);
};

/**
 * param: groupId => String
 * return:
 * exception:
 * Description : Delete Validation list corresponding to groupId
 */
const deleteValidList = (el, groupId) => {
    for (let i = 0; i < validList.length; i += 1) {
        if (validList[i].groupId === groupId && validList[i].el === el) {
            validList.splice(i, 1);
            // i -= -1;
            break;
        }
    }
};

/**
 * param: groupId => String
 * return:
 * exception:
 * Description : Call all onBlur events on page
 */
const onSubmitValidation = groupId => {
    if (!groupId) {
        groupId = '';
    }
    let flag = false;
    for (let i = 0; i < validList.length; i += 1) {
        if (validList[i].groupId === groupId) {
            validList[i].el.focus();
            validList[i].el.blur();
            if (validList[i].el.classList.contains('warning')) {
                // validList[i].focus();
                flag = true;
                break;
            }
        }
    }
    return flag;
};

/**
 * param:
 * return:
 * exception:
 * Description : delete all warning css
 */
const clearAllIsInvalidCss = () => {
    let test = Array.from(document.querySelectorAll('.warning')).map(ele => ele.classList.remove('warning'));
};

/**
 * param:
 * return:
 * exception:
 * Description : parse jwttoken
 */
const parseJwt = token => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map(c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
            .join(''),
    );

    return JSON.parse(jsonPayload);
};


/**
 * param: url, title, width, height
 * return: new Popup Window
 * exception:
 * Description : it will open a new popup window in the center
 *  https://stackoverflow.com/questions/4068373/center-a-popup-window-on-screen
 */
const openLegacyWindowPopup = ({url, title, w, h}) => {
    // Fixes dual-screen position                             Most browsers      Firefox
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    const systemZoom = width / window.screen.availWidth;
    const left = (width - w) / 2 / systemZoom + dualScreenLeft;
    const top = (height - h) / 3 / systemZoom + dualScreenTop;
    const newWindow = window.open(url, title, ` scrollbars=yes, resizable=yes, width=${w / systemZoom}, height=${h / systemZoom}, top=${top}, left=${left}`);

    const browser = navigator.userAgent.toLowerCase();
    if (browser.indexOf('chrome') > 0) {
        if (window.focus) newWindow.focus();
    }
    return newWindow;
};

const isIE11 = () => /Trident.*rv[ :]*11\./.test(navigator.userAgent);

const getMacAddress = () => {
    Vue.$log.warn('FYI, getMacAddress() only works with IE.');

    try {
        let obj = new ActiveXObject("WbemScripting.SWbemLocator");
        let s = obj.ConnectServer ( "." );
        let properties = s.ExecQuery("SELECT * FROM Win32_NetworkAdapterConfiguration");
        let e = new Enumerator(properties);
        while(!e.atEnd()) {
            e.moveNext();
            let p = e.item();
            if (!p)
                continue;
            if (p.IPAddress == null) {
                return '';
            }

            const macAddress = p.MACAddress.split(":").join("");
            Vue.$log.debug('MAC Address: ', macAddress);
            return macAddress;
        }
    } catch(err) {
        //alert ("code:" + e.number +",desc:" + e.description);
        return '';
    }
};

/*
 * desc : 빈값반환규칙
 * strA가 빈값이면 strB반환 또는 strB도 빈값이면 '' 반환
 * strA가 빈값이 아니면 strA반환 또는 strC가 있다면 strA가 아니라 strC반환
 * param : {
 *           strA : String
 *           strB : String
 *           strC : String
 *         }
 * @deprecated
 */
const nvl = (strA, strB, strC) => { return StringUtil.nvl(strA, strB, strC); };

/**
 * Null check
 * param: v
 * return: boolean
 * @deprecated
 */
const isNull = (v) => { return StringUtil.isNull(v); };

/**
 * Text length check function
 * param: v, max, min
 * return: boolean
 * @deprecated
 */
const lengthCheck = (v, max, min) => { return StringUtil.lengthCheck(v, max, min); };

/**
 * Text length return function
 * return: (int) text length
 * @deprecated
 */
const textLength = (v) => { return StringUtil.textLength(v); };

/*
 * 배열에서 object 존재여부 체크(true: 존재함)
 * @deprecated
 */
const existArrays = (array, key, val) => { return StringUtil.existArrays(array, key, val); };

/*
 * 정수만 입력 가능
 * @deprecated
 */
const onlyNumber = (event) => { return StringUtil.onlyNumber(event); };

/*
 * 숫자와 하이픈까지만 허용, 나머지는 삭제
*/
const onlyNumber2 = (event) => {
    return $(event.target).val($(event.target).val().replace(/[^0-9|^-]/g, '').replace(/--/g, '-'));
};

/*
 * html 제거
 * @deprecated
 */
const stripHtml = (html) => { return StringUtil.stripHtml(html); };

/*
 * 소숫점 아래 자르기
 * @deprecated
 */
const cutComma = (numb, delim) => {
    let main = '';
    let strs = String(numb).split('.');
    if (strs.length > 1) {
        let aft = strs[1];
        if (!delim) main = strs[0];
        else main = strs[0] + '.' + aft.substring(0, delim);
    } else {
        main = numb;
    }
    return main;
};

/*
 * decode
 * @deprecated
 */
const convertHtml = (sVal) => { if (!sVal) sVal = ''; return StringUtil.decodeXSS(sVal); };

const getRequest = (path, params = null) => {
    path = path ? path : '/';
    if (path[0] !== '/') path.unshift('/');
    return axios
        .get(`${API_URL}${path}`, {params} )
        .then(res => {
            Vue.$log.debug('GET RESULT =>> ', res);
            return res.data;
        })
        .catch(async (err) => {
            Vue.$log.error('GET ERROR =>> ', err);
            if (err.data.error.code === 'HHP_NO_CERTINFO') {
                await getRequest('/basis/certificate/CertMain.skp');
                return await getRequest(path, params);

            } else if (err.data.error.code === 'HHP_LOGIN_REQUIRED') {

            }

            return Promise.reject(Object.assign(err, new Error(err.data.error.message)));
        });
};

const postForm = (path, formData = {}) => {
    path = path ? path : '/';
    if (path[0] !== '/') path.unshift('/');
    return axios
        .post(
            `${API_URL}${path}`,
            qs.stringify(formData),
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            },
        )
        .then(res => {
            Vue.$log.debug('SDLUtil.js postForm result =>> ', res);
            return res.data;
        })
        .catch(err => {
            Vue.$log.error('SDLUtil.js postForm ERROR =>> ', err);
            return Promise.reject(Object.assign(err, new Error(err.data.error.message)));
        });
};

const deleteAttach = (attachFileSeq, encToken) => {
    const path = '/basis/common/attachRemove.skp';
    const params = {
        attachFileSeq: attachFileSeq,
        encToken: encToken,
    };
    return axios.post(path, { params });
};

const isErrorResponse = (data) => {
    return Object.prototype.hasOwnProperty.call(data, 'error');
};

function sortArray(arrObj, key) {
    arrObj.sort(function(a, b) {
        return eval('a.' + key) < eval('b.' + key) ? -1 : eval('a.' + key) > eval('b.' + key) ? 1 : 0;
    });
    return arrObj;
};

function convertDate(date) {
    let str = "";
    let mode = date.indexOf("-");
    if (mode < 0) {
        str = date.substring(6) + "-" + date.substring(0, 5).replace(".", "-");
    } else {
        str = date.substring(5).replace("-", ".") + "." + date.substring(0, 4);
    }
    return str;
};

const setNoticeRead = (noticeSeq) => {
    const cookieName = 'notice-popup-dont_show_'+ noticeSeq
    const cookieValue = '1';
    const now = new Date();
    now.setDate(now.getDate() + 1);
    now.setHours(0);
    now.setMinutes(0);
    const expires = "expires="+ now.toString();

    Vue.$log.info('SDLUtil.setNoticeRead() expires', expires);

    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
};

const isNoticeRead = (noticeSeq) => {
    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    const cookieName = 'notice-popup-dont_show_' + noticeSeq
    const cookieValue = getCookie(cookieName);
    Vue.$log.info('SDLUtil.isNoticeRead() cookie value', cookieValue);
    return  cookieValue!== '';
};

// 2020.09.08 김남갑 추가
const isEmail = (email) => {
    let bRes = false;
    if (!email || email.length < 7) return false;

    if (email.indexOf('@') < 0 || email.indexOf('.') < 0) {
        bRes = false;
    } else {
        bRes = true;
    }
    return bRes;
};

const isPermitUploadFile = (fileName) => {
    let bFileAllow = true;
    const permitFiles = ['jpeg', 'jpg', 'gif', 'bmp', 'png', 'pdf'];

    let idx = fileName.lastIndexOf('.');
    let fExt = fileName.substring(idx+1).toLowerCase();
    if (!permitFiles.includes(fExt)) {
        alert('MESSAGE.EUR.NO.PERMIT.FILE');
        bFileAllow = false;
        return bFileAllow;
    }

    const noPermitNames = ['%', ';', '#', '&', '+', ','];
    noPermitNames.forEach(elm=> {
        if (fileName.indexOf(elm) > -1) {
            alert('MESSAGE.EUR.NO.FILE.NAME');
            bFileAllow = false;
            return bFileAllow;
        }
    });

    return bFileAllow;
};

export default {
    API_URL,
    API_CONTEXT_PATH,
    WEB_CONTEXT_PATH,
    DOTCOM_URL,
    IS_DEV_MODE,
    isLogin,
    isLocal,
    isMobile,
    isTokenExpire,
    getLoginedUserInfo,
    isRoleExist,
    getMsgProp,
    getI18nLanguage,
    setI18nLanguage,
    alert,
    errorAlert,
    confirm,
    show,
    showLoadingBar,
    getCommCodeList,
    getBoardSearchParams,
    importJS,
    importCSS,
    formParameters,
    onSubmitValidation,
    getValidList,
    setValidList,
    deleteValidList,
    clearAllIsInvalidCss,
    parseJwt,
    openLegacyWindowPopup,
    isIE11,
    getMacAddress,
    nvl,
    isNull,
    lengthCheck,
    textLength,
    existArrays,
    onlyNumber,
    onlyNumber2,
    cutComma,
    stripHtml,
    getRequest,
    postForm,
    isErrorResponse,
    sortArray,
    convertDate,
    deleteAttach,
    setNoticeRead,
    isNoticeRead,
    convertHtml,
    isEmail,
    isEurLogin,
    isPermitUploadFile
};



// WEBPACK FOOTER //
// ./src/utils/SDLUtil.js